/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InitiativeImageReference } from '../../models/initiative-image-reference';

export interface GetInitiativeImageReference$Params {
  initiativeId: string;
  id: string;
}

export function getInitiativeImageReference(http: HttpClient, rootUrl: string, params: GetInitiativeImageReference$Params, context?: HttpContext): Observable<StrictHttpResponse<InitiativeImageReference>> {
  const rb = new RequestBuilder(rootUrl, getInitiativeImageReference.PATH, 'get');
  if (params) {
    rb.path('initiativeId', params.initiativeId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InitiativeImageReference>;
    })
  );
}

getInitiativeImageReference.PATH = '/initiative/{initiativeId}/images/{id}';
